<!--  -->
<template>
    <div class="cardbg box box_v" :class="{chartbig:big}">
        <div class="subtitlebox box">
            <div class="xian xianleft box_f1"></div>
            <div class="subtitle box" :style="{fontSize: fontSize+'px'}">{{title}}</div>
            <div class="xian xianright box_f1"></div>
        </div>
        <div class="box_f1"><slot></slot></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    props: {
      title:null,
      big:null,
      fontSize:{
        type:null,
        default:16
      }
    },
    components: {},
    data() {
    //这里存放数据
        return {

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.cardbg{
    width: 100%;
    height: 100%;
    background-image: url('../../../assets/images/monitor/rect-s.png');
    background-size: 100% 100%;
}
.chartbig{
    background-image: url('../../../assets/images/monitor/rect-m.png') !important;
}
.subtitlebox{
    width: 100%;
    line-height: 34px;
    height: 34px
}
.subtitle{
    margin:0 20px;
    color:#fff;
}
.xian{
    height: 4px;
    margin-top: 15px;
}
.xianleft{
    background-image: linear-gradient(-90deg , rgba(255, 255, 255,.3) 0%,rgba(255,255,255,0) 50%);
    border-radius: 4px 0;
}
.xianright{
    background-image: linear-gradient(90deg , rgba(255, 255, 255,.3) 0%,rgba(255,255,255,0) 50%);
    border-radius: 4px;
}
</style>
